import * as React from 'react';
import { ArticleHeading1, UIText1 } from '@cian/ui-kit/typography';
import * as styles from './styles.css';

interface IGeneralInfoMobileProps {
  name: string;
  companyName?: string;
  age?: string;
}

export const GeneralInfoMobile: React.FunctionComponent<React.PropsWithChildren<IGeneralInfoMobileProps>> = ({
  name,
  companyName,
  age,
}) => {
  return (
    <>
      <ArticleHeading1>{name}</ArticleHeading1>
      {!!companyName && !!age && (
        <div className={styles['description']}>
          <UIText1>
            {!!companyName && companyName}
            {!!companyName && !!age && <br />}
            {!!age && `${age} на ЦИАН`}
          </UIText1>
        </div>
      )}
    </>
  );
};
